import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VeeValidate from 'vee-validate';
import VueMeta from 'vue-meta';
import store from './store';
import './ml'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VueTelInput from 'vue-tel-input'
import browserDetect from "vue-browser-detect-plugin";


Vue.use(VeeValidate);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});
Vue.use(VueQuillEditor, /* { default global options } */)

Vue.use(browserDetect);

Vue.use(VueTelInput, {
    preferredCountries: ['RU'],
    validCharactersOnly: true,
    mode: "international",
    disabledFetchingCountry: true,
    enabledCountryCode: true
});


Vue.use({
  install: function(Vue, options){
    Vue.prototype.$jQuery = require('jquery');
  }
});

Vue.config.productionTip = false;



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
